module.exports = require('./helpers/bundle-url').getBundleURL('au4zy') + "crown.1ad9caeb.svg" + "?" + Date.now();